import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { localizeContent, translate } from "../lib/i18n";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [rawContent, setContent] = useState(null);
  const [lang, setLangState] = useState(() => localStorage.getItem("sw_lang") || "en");
  const setLang = (l) => { localStorage.setItem("sw_lang", l); setLangState(l); };
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const content = useMemo(() => localizeContent(rawContent, lang), [rawContent, lang]);
  const t = useCallback((s, vars) => translate(lang, s, vars), [lang]);
  const [products, setProducts] = useState([]);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatPrefill, setChatPrefill] = useState("");

  const refresh = useCallback(async () => {
    try {
      const [c, p] = await Promise.all([api.get("/content"), api.get("/products")]);
      setContent(c.data);
      setProducts(p.data);
    } catch (e) {
      console.error("Failed to load site data", e);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const openChat = (prefill = "") => {
    setChatPrefill(typeof prefill === "string" ? prefill : "");
    setChatOpen(true);
  };

  return (
    <SiteContext.Provider
      value={{ content, rawContent, lang, setLang, t, products, refresh, setContent, setProducts, chatOpen, setChatOpen, openChat, chatPrefill, setChatPrefill }}
    >
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
